import { Button, Divider, Form, Input } from "antd";
import React, { useState } from "react";

const Login = ({ onLogin }) => {
  const [form] = Form.useForm();
  const [accessCode, setAccessCode] = useState("");

  const handleSubmit = () => {
    if (accessCode === "AbnJ@11-21") {
      onLogin(true);
    } else {
      alert("Invalid credentials");
    }
  };

  return (
    <div
      style={{
        margin: "10px",
        padding: "20px",
        width: "300px",
        borderRadius: "10px",
        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
        background: "#fff",
      }}
    >
      <h3 style={{ margin: "0" }}>Login</h3>

      <Divider></Divider>

      <Form
        name="loginForm"
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          label="Access Code"
          name="accessCode"
          rules={[{ required: true, message: "Please input the access code!" }]}
        >
          <Input.Password onChange={(e) => setAccessCode(e.target.value)} />
        </Form.Item>

        <Button type="primary" htmlType="submit" style={{ margin: "10px 0 0" }}>
          Submit
        </Button>
      </Form>
    </div>
  );
};

export default Login;
